module.exports = __webpack_public_path__ + "img/chair_cover.1bc70eb9.png";